import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {saveAs} from 'file-saver';
@Injectable({
    providedIn: 'root'
})
export class DownloadService {

    constructor(protected http: HttpClient) {
    }

    downloadFileByPost(url, params, fileName) {
        const formData = {
            params: params
        };
        this.http.post(url, formData, { responseType: 'blob' }).subscribe((response: Blob) => {
            saveAs(response, fileName);
        });
    }
}
